export var uiCheck = [
    'M12.4 4.19L5.9 10.69L3.6 8.39C3.49 8.29 3.32 8.29 3.21 8.39L2.95 8.66C2.84 8.77 2.84 8.94 2.95 9.05L5.7 11.81C5.81 11.92 5.99 11.92 6.1 11.81L13.05 4.85C13.16 4.74 13.16 4.56 13.05 4.46L12.79 4.19C12.68 4.08 12.51 4.08 12.4 4.19Z',
];
